import { useEffect } from 'react';
import { useLocation } from 'react-router';
// @mui
import { Box, Drawer } from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// config
import { NAV } from '../../../config-global';
// components
import Scrollbar from '../../../components/scrollbar';
import { NavListProps, NavSectionVertical } from '../../../components/nav-section';
//
import { createNavConfig } from './config-navigation';
import NavToggleButton from './NavToggleButton';
import { useGetConfigurationQuery } from '../../../redux/slices/apiSlice';
import { useAuthContext } from '../../../auth/useAuthContext';
import Label from '../../../components/label';
import { useReleaseNotes } from '../../../release-notes/ReleaseNotesContext';

// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const { pathname } = useLocation();
  const { latestReleaseNote } = useReleaseNotes();

  const isDesktop = useResponsive('up', 'lg');

  const { data, isSuccess, error } = useGetConfigurationQuery();
  const { user } = useAuthContext();
  let localNavConfig: {
    subheader: string;
    items: NavListProps[];
  }[] = [];

  if (isSuccess) {
    console.log(`### configuration: ${JSON.stringify(data)}`);
    if (data) {
      localNavConfig = createNavConfig(data, user);
    }
  } else {
    console.log(`### Error loading configuration: ${error}`);
  }

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <NavSectionVertical data={localNavConfig} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
        marginTop: 10,
      }}
    >
      <NavToggleButton />

      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 0,
              width: NAV.W_DASHBOARD,
              bgcolor: 'transparent',
              borderRightStyle: 'dashed',
              marginTop: 2,
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
      {latestReleaseNote && (
        <Label
          sx={{
            position: 'fixed',
            bottom: 16,
            left: 16,
            zIndex: 1,
          }}
        >
          v{latestReleaseNote.version}
        </Label>
      )}
    </Box>
  );
}
